import { createFileRoute } from '@tanstack/react-router';

import AdminMeetupDetailPage from '@/pages/admin/AdminMeetupDetailPage';

export const Route = createFileRoute('/admin/meetup/$meetupId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { meetupId } = Route.useParams();
  return <AdminMeetupDetailPage meetupId={meetupId} />;
}
